import fetch from "auth/FetchInterceptor";

const InstructorsService = {};

const instructorEndpointPrefix = "/formateur";

InstructorsService.createInstructor = async (data) =>
    await fetch({
        url: `${instructorEndpointPrefix}/createFormer`,
        method: "POST",
        data,
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });

InstructorsService.getInstructors = async () =>
    await fetch({
        url: `${instructorEndpointPrefix}/getAll`,
        method: "GET",
    });

InstructorsService.getInstructorById = async (id) =>
    await fetch({
        url: `${instructorEndpointPrefix}/getById/${id}`,
        method: "GET",
    });

InstructorsService.updateInstructorById = async (id, data) =>
    await fetch({
        url: `${instructorEndpointPrefix}/update/${id}`,
        method: "PUT",
        data,
    });

InstructorsService.deleteInstructorById = async (id) =>
    await fetch({
        url: `${instructorEndpointPrefix}/deleteById/${id}`,
        method: "DELETE",
    });

InstructorsService.validateInstructorById = async (id) =>
    await fetch({
        url: `${instructorEndpointPrefix}/validateAccount/${id}`,
        method: "POST",
    });

InstructorsService.banInstructorById = async (id, data) =>
    await fetch({
        url: `${instructorEndpointPrefix}/bannedAccount/${id}`,
        method: "POST",
        data,
    });

// --- Assignation formateur -> formation / cours de soutien / groupe ---

// Formations où le formateur n'apparaît pas du tout dans instructors
InstructorsService.getAvailableTrainings = async (id, params) =>
    await fetch({
        url: `${instructorEndpointPrefix}/${id}/available-trainings`,
        method: "GET",
        params,
    });

// Cours de soutien dont ce formateur n'est pas le formateur
InstructorsService.getAvailableSupportCourses = async (id, params) =>
    await fetch({
        url: `${instructorEndpointPrefix}/${id}/available-support-courses`,
        method: "GET",
        params,
    });

// Groupes rattachés à une formation / un cours de soutien où le formateur est déjà présent
InstructorsService.getAvailableGroups = async (id, params) =>
    await fetch({
        url: `${instructorEndpointPrefix}/${id}/available-groups`,
        method: "GET",
        params,
    });

// Tutoriels dont ce formateur n'est pas l'enseignant.
// `onlyUnassigned: true` restreint aux tutoriels sans aucun enseignant.
InstructorsService.getAvailableTutorials = async (id, params) =>
    await fetch({
        url: `${instructorEndpointPrefix}/${id}/available-tutorials`,
        method: "GET",
        params,
    });

export default InstructorsService;
